<template>
    <!--
    <div class="gq_action_node gq_node" href="#">
    <div class="gq_answer_node gq_node" href="#" @click="click">
    <div class="gq_question_node gq_node" href="#" @click="click">
    <div class="gq_linked_question_node gq_node" href="#" @click="click">
    <div class="form_node gq_node" href="#" :class="{
            gq_web_node: hasFormType('webForm') || formTypes == null || formTypes.length == 0,
            gq_pdf_node: hasFormType('pdfForm'),
            gq_link_node: hasFormType('link'),
            gq_contact_node: hasFormType('contact'),
            gq_content_node: hasFormType('content')
        }" @click="click">
    -->
    <div :class="nodeClasses" href="#" @click.prevent="click">
        <!--
        {{ type }}
        -->
        <!-- question -->
        <template v-if="type == 'Question'">
            <span class="node_addon">Q</span>
            <a class="node_body">
                <span>{{ questionText }}</span>
                <span style="color: #bebebe" v-show="!questionText">No question entered</span>
            </a>
        </template>

        <!-- answer -->
        <template v-if="type == 'Answer'">
            <span class="node_addon">A</span>
            <a class="node_body">
                <span>{{ answerText }}</span>
                <span style="color: #616161" v-show="!answerText">No answer entered</span>
            </a>
        </template>

        <!-- linked question -->
        <template v-if="type == 'LinkedQuestion'">
            <span class="node_addon">L</span>
            <a class="node_body">
                <span v-if="link != null">
                    <span>{{ link.questionText }}</span>
                    <span class="badge badge-light" v-show="link.tenant != defaultTenantCode">
                        <TenantDisplay :tenant="link.tenant" />
                    </span>
                </span>
                <span style="color: #616161" v-show="link == null">No question linked</span>
            </a>
        </template>

        <!-- form -->
        <template v-if="type == 'Form'">
            <span class="node_addon" :title="titleAttr"></span>
            <a class="node_body">
                <span>{{ label }}</span>
                <span class="ml-1 badge badge-light" v-show="formTenant != defaultTenantCode">
                    <TenantDisplay :tenant="formTenant" />
                </span>
                <span style="color: #616161" v-show="!label">No item selected</span>
            </a>
        </template>

        <!-- node action -->
        <template v-if="type == 'ActionTemplate'">
            <span class="node_addon">
                <span class="plus-sign">+</span>
            </span>
            <a class="node_body add_question" style="border-left: 1px solid #ddd" @click="click2('newQuestion')"> New Question </a>
            <a class="node_body add_form" style="border-left: 1px solid #ddd" @click="click2('newForm')"> Link </a>
            <a v-show="hasOtherTenantQuestions" class="node_body add_question_link" style="border-left: 1px solid #ddd" @click="click2('newLinkedQuestion')"> Question Link </a>
        </template>
    </div>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import { CQActionTemplateNode, CQAnswerNode, CQQuestionNode, CQLinkedQuestionNode, CQFormNode } from "./nodes";
import TenantDisplay from "./TenantDisplay.3.vue";
interface Props {
    node: CQActionTemplateNode & CQAnswerNode & CQQuestionNode & CQLinkedQuestionNode & CQFormNode;
    defaultTenantCode?: string;
    clickFunc: (type?: string) => void;
    hasOtherTenantQuestions: boolean;
}
export default defineComponent({
    props: ["node", "defaultTenantCode", "clickFunc", "hasOtherTenantQuestions"],
    setup(props: Props) {
        const formTenant = computed(() => {
            return props.node.tenant;
        });
        const titleAttr = computed(() => {
            return props.node.titleAttr();
        });
        const id = computed(() => props.node.id);
        const type = computed(() => props.node.type);
        const questionText = computed(() => props.node.questionText);
        const answerText = computed(() => props.node.answerText);
        const formTypes = computed(() => props.node.formTypes);
        const label = computed(() => props.node.label);
        const link = computed(() => props.node.link);
        const nodeClasses = computed(() => {
            let result = ["gq_node"];
            if (type.value == "Question") {
                result.push("gq_question_node");
            } else if (type.value == "Answer") {
                result.push("gq_answer_node");
            } else if (type.value == "LinkedQuestion") {
                result.push("gq_linked_question_node");
            } else if (type.value == "Form") {
                result.push("gq_form_node");
                if (props.node.hasFormType("webForm")) {
                    result.push("gq_web_node");
                }
                if (props.node.hasFormType("pdfForm")) {
                    result.push("gq_pdf_node");
                }
                if (props.node.hasFormType("link")) {
                    result.push("gq_link_node");
                }
                if (props.node.hasFormType("contact")) {
                    result.push("gq_contact_node");
                }
                if (props.node.hasFormType("content")) {
                    result.push("gq_content_node");
                }
            } else if (type.value == "ActionTemplate") {
                result.push("gq_action_node");
            } else {
                debugger;
            }
            if (!props.node.isThisValid()) {
                result.push("error");
            }
            return result;
        });

        const click = () => {
            if (type.value == "ActionTemplate") {
                return;
            }
            props.clickFunc();
        };
        const click2 = (type: string) => {
            props.clickFunc(type);
        };
        // const getTenantDisplayLabel = (tenants: string) => {
        //     return props.node.root().component.$root.getTenantDisplayLabel(tenants);
        // };

        return {
            // States
            formTenant,
            titleAttr,
            nodeClasses,
            id,
            type,
            questionText,
            answerText,
            formTypes,
            label,
            link,

            // Methods
            click,
            click2,
            // getTenantDisplayLabel,
        };
    },
    components: {
        TenantDisplay,
    },
});
</script>
